export default __webpack_public_path__ + "static/media/photo-charte12.68ef4e07.png";